<template>
  <div class="pb-3">
    <section id="api_tasks_list" class="pt-2">
      <h4 class="pb-2">Список задач</h4>
      <div class="nav-api">
        <ul class="nav nav-tabs nav-tabs-clean">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="post">GET</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">{{ url }}/{{ method }}</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>type</td>
                  <td>строка</td>
                  <td>обязательный параметр</td>
                  <td>тип задачи (http или ping)</td>
                </tr>
                <tr>
                  <td>group_id</td>
                  <td>целое число</td>
                  <td></td>
                  <td>ID категории</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="example">Пример</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div
            class="tab-pane fade show active">curl -X POST -H "Authorization: Bearer {{ token }}" {{ url }}/{{ method }}/http</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="success">Ответ</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">
            <pre class="mb-0">HTTP/1.1 200 OK
{
  "status": "success",
  "data": [
    {
      "contacts": [
        {
          "value": "{{ user.mail }}",
          "name": "Название контакта",
          "id": 18
        }
      ],
      "settings": {
        "keyword": "OK"
      },
      "group_id": 72,
      "statistics": {
        "duration": "1 неделя",
        "response": 311.62,
        "uptime": {
          "month": "99.98",
          "year": "99.98",
          "week": 100,
          "day": 100
        }
      },
      "id": 46,
      "name": "Мониторинг",
      "type": "http",
      "link": "uptime.center",
      "value": "https://uptime.center",
      "frequency": 1,
      "status": "up",
      "state": "on"
    }
  ]
}</pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token', 'user'],
    data() {
      return {
        method: 'v1/tasks'
      }
    }
  }
</script>